import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { Title } from '../General/Title';
import { rem, rgba } from 'polished';
import { __ } from 'react-i18n';

interface Props {
  endedDate: Date;
  title: string;
  description: string;
  imageUrl: string;
  url?: string;
}

export const Action = ({
  endedDate,
  title,
  description,
  imageUrl,
  url,
}: Props): JSX.Element => {
  const [now, setNow] = React.useState(new Date().getTime());
  const endedDateTime = new Date(endedDate).getTime();
  const timeDiff = endedDateTime - now;

  let isEnded = false;
  let printedTime = '';

  if (timeDiff <= 0) {
    isEnded = true;
  } else {
    isEnded = false;
    const diffDays = timeDiff / (1000 * 3600 * 24);
    const diffHours = ((timeDiff - diffDays) / (1000 * 3600)) % 24;
    const diffMinutes = ((timeDiff - diffHours) / (1000 * 60)) % 60;
    const daysString = `${Math.trunc(diffDays)}d`;
    const hoursString = `${Math.trunc(diffHours)}h`;
    const minutesString = `${Math.trunc(diffMinutes)}m`;
    printedTime = `${daysString} ${hoursString} ${minutesString}`;
  }

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date().getTime());
    }, 1000);
    return () => {
      return clearInterval(interval);
    };
  }, []);

  return (
    <Wrapper to={url ? url : null}>
      <HeaderWrapper>
        <Badge isEnded={isEnded}>
          {!isEnded ? `${printedTime}` : __('UKONČENÉ')}
        </Badge>
        <ImageWrapper imageUrl={imageUrl} isEnded={isEnded} />
      </HeaderWrapper>
      <ContentWrapper>
        <StyledTitle isEnded={isEnded}>{title}</StyledTitle>
        <StyledContent
          isEnded={isEnded}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled(Link)`
  /* max-width: ${rem(464)}; */
  padding-bottom: ${rem(40)};
  text-decoration: none;
`;

const HeaderWrapper = styled.header`
  height: ${rem(240)};
  margin-bottom: ${rem(32)};
  position: relative;
  overflow: hidden;
`;

const ContentWrapper = styled.div``;

const StyledTitle = styled(Title)<{ isEnded: boolean }>`
  font-size: ${rem(24)};
  line-height: ${rem(31.2)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  margin-top: 0;
  margin-bottom: ${rem(16)};

  ${props =>
    props.isEnded
      ? `
      color: #AAAAAA;
      `
      : ''}
`;

const StyledContent = styled.p<{ isEnded: boolean }>`
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;

  ${props =>
    props.isEnded
      ? `
      color: #AAAAAA;
      `
      : ''}
`;

const ImageWrapper = styled.div<{ imageUrl: string; isEnded: boolean }>`
  background: center/cover no-repeat url(${props => props.imageUrl});
  height: 100%;
  border-radius: ${rem(4)};

  ${props =>
    props.isEnded
      ? `
      mix-blend-mode: luminosity;
      opacity: 0.56;
      `
      : ''}
`;

const Badge = styled.span<{ isEnded: boolean }>`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  font-size: ${rem(20)};
  line-height: ${rem(31)};
  background: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;
  transform: matrix(0.71, -0.71, 0.71, 0.71, 0, 0);
  width: ${rem(200)};
  left: ${rem(-50)};
  top: ${rem(30)};
  padding: ${rem(8)} 0;
  z-index: 1;

  ${props =>
    props.isEnded
      ? `
      background-color: rgb(216, 56, 58);
      text-transform: uppercase;
      `
      : ''}
`;
